/** Stable no-op function for optional callback fallbacks. */
export const noop = (): void => {};
